import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Typography,
  TextField,
} from "@mui/material";

const cellSx = {
  backgroundColor: "rgba(47, 53, 71, 0.9)",
  border: "1.5px solid #fff",
  color: "white",
  padding: "10px 8px",
};

const numberSx = {
  ...cellSx,
  textAlign: "center",
  fontWeight: 700,
  fontSize: 22,
};

const IPSSeveranceTable = ({ ipsSeverance = 0, onValuesChange }) => {
  const [editableIpsSeverance, setEditableIpsSeverance] = useState(
    Number(ipsSeverance).toFixed(2)
  );

  useEffect(() => {
    setEditableIpsSeverance(Number(ipsSeverance).toFixed(2));
  }, [ipsSeverance]);

  const handleInputChange = (event) => {
    const val = event.target.value;
    if (val === "" || /^\d*\.?\d*$/.test(val)) {
      setEditableIpsSeverance(val);
      if (typeof onValuesChange === "function") {
        onValuesChange(Number(val) || 0);
      }
    }
  };

  return (
    <Box mt={4}>
      <Typography variant="h6" mb={2} fontWeight="bold" color="white">
        Indemnizacion IPS
      </Typography>
      <TableContainer component={Paper} sx={{ background: "rgba(47,53,71,0.9)" }}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell sx={{ ...cellSx, fontWeight: 700 }}>IPS Indemnizacion (Total)</TableCell>
              <TableCell
                sx={{
                  ...numberSx,
                  background: "rgba(34,189,110,0.15)",
                  color: "#3afa60",
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: 20,
                }}
              >
                <TextField
                  value={editableIpsSeverance}
                  onChange={handleInputChange}
                  variant="standard"
                  inputProps={{
                    style: { color: "white", fontWeight: 700, textAlign: "center" },
                    inputMode: "decimal",
                    autoComplete: "off",
                    spellCheck: false,
                    maxLength: 12,
                  }}
                  sx={{
                    "& .MuiInputBase-input": { textAlign: "center", color: "white", fontWeight: 700 },
                    width: "140px",
                    background: "rgba(0,0,0,0.15)",
                    borderRadius: 1,
                  }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default IPSSeveranceTable;
